import DateTime from "../../vendor/luxon/src/datetime.js";
import "../../vendor/luxon/src/duration.js";
import { DateTimeFormat } from "./types/DateTimeFormat.js";
const DEFAULT_START_YEAR = DateTime.now().year, DEFAULT_END_YEAR = DEFAULT_START_YEAR - 200, DEFAULT_YEAR_RANGE = [DEFAULT_START_YEAR, DEFAULT_END_YEAR], PARSING_FORMAT = DateTimeFormat.ISODate, TIME_PARSING_FORMAT = DateTimeFormat.ISOTime;
export {
  DEFAULT_YEAR_RANGE,
  PARSING_FORMAT,
  TIME_PARSING_FORMAT
};
//# sourceMappingURL=constants.js.map
